module.exports = __webpack_public_path__ + "assets/1792649897182/img/map-driver-icon.c7ff3298.png";